export enum UserRolesEnum {
    GlobalSuperAdmin = "GlobalSuperAdmin",
    ProjectSuperAdmin = "ProjectSuperAdmin",
    Other = "Other"
}
